export default "__VITE_ASSET__BJqGVx7W__"